// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".info-awesome-icon .a {\n  stroke: var(--primary-color);\n  stroke-width: 1.5px;\n}", ""]);
// Exports
module.exports = exports;
